import { Dispatch } from "react";
import { Action, ActionType } from "../actions";
import PluginService from "../../services/pluginService";
import { IPluginConfiguration } from "../../models/configuration/plugin/IConfiguration";
import { ensureRequiredDeliveryTypes, ensureSpecialDeliveryTypes } from "../../utils/deliveryTypeHelper";

const getConfigPlugInData = (configId: string, token: string | null, reloadPluginConfig?: boolean): (dispatch: Dispatch<Action>, getState: () => any) => Promise<boolean> => {
    return async (dispatch: Dispatch<Action>, getState: () => any) => {

        dispatch({ type: ActionType.GET_CONFIG_PLUGIN_DATA });

        try {

            const plugInData = getState().configPlugInData.data;

            if (plugInData !== null && !reloadPluginConfig) { // Checking for exiting state data and if we need to reload the plugin config
                dispatch({
                    type: ActionType.GET_CONFIG_PLUGIN_DATA_SUCCESS,
                    payload: plugInData,
                    fromServer: false
                });
                return true;
            } else {
                const payload = await new PluginService().getEpcApiConfig<IPluginConfiguration>(token, "plugin", configId);

                const state = getState();
                const isTPOConnectTraffic = state?.originSlice?.isTPOConnectTraffic;
                const enableTpo = payload?.Configuration?.EnableTpo;

                if (isTPOConnectTraffic && !enableTpo) {
                    const payloadErrorMessage = `Your account is not configured to utilize TPO Connect with Docutech.
                    Please reach out to your Docutech account manager if you wish to utilize this feature.`;
                    dispatch({
                        type: ActionType.TPO_VALIDATION_ERROR, // Use specific TPO error action
                        payload: payloadErrorMessage,
                    });
                    return false;
                }

                // Ensure static and special delivery types
                payload.Configuration.DeliveryTypes = ensureSpecialDeliveryTypes(
                    ensureRequiredDeliveryTypes(payload.Configuration.DeliveryTypes)
                );

                dispatch({
                    type: ActionType.GET_CONFIG_PLUGIN_DATA_SUCCESS,
                    payload: payload,
                    fromServer: true
                });
                return true;
            }

        } catch (error: any) {
            console.error("Get Config Plugin Data");
            if (error instanceof Error) {
                const payloadErrorMessage = `Failed to fetch Config Plugin Data: (${error.message})`;
                dispatch({
                    type: ActionType.GET_CONFIG_PLUGIN_DATA_FAILURE,
                    payload: payloadErrorMessage,
                });
            }
            return false;
        }
    }
}

export default getConfigPlugInData;